import { render, staticRenderFns } from "./AddEditQuestionTextAnswer.vue?vue&type=template&id=05a7638d"
import script from "./AddEditQuestionTextAnswer.vue?vue&type=script&lang=js"
export * from "./AddEditQuestionTextAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports